import { TermsConditionsDialogOptions } from '@fleet-beat/shared';

export const termsConditionsDialogDefaultOptions: TermsConditionsDialogOptions<boolean> = {
  title: 'Terms and Conditions',
  buttons: [
    {
      caption: 'Close',
      action: false,
    },
    {
      caption: 'Agree',
      action: true,
    },
  ],
};
